module.exports = __webpack_public_path__ + "static/fonts/iconfont.028f42c0.woff";